if (!customElements.get('judge-me-review-widget')) {
  function getFormattedDate(dateString) {
    // Manually parse the date string
    const dateParts = dateString.split(' ');
    if (dateParts.length !== 3) {
        throw new Error(`Invalid date string: ${dateString}`);
    }

    const [datePart, timePart, timeZone] = dateParts;

    if (timeZone !== 'UTC') {
        throw new Error(`Unsupported time zone: ${timeZone}`);
    }

    const [year, month, day] = datePart.split('-').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);

    // Create a Date object in UTC
    const date = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));

    // Validate the constructed date
    if (isNaN(date)) {
        throw new Error(`Failed to parse date: ${dateString}`);
    }

    // Format the date
    const formattedMonth = (1 + date.getUTCMonth()).toString().padStart(2, '0');
    const formattedDay = date.getUTCDate().toString().padStart(2, '0');
    const formattedYear = date.getUTCFullYear();

    return `${formattedMonth}/${formattedDay}/${formattedYear}`;
  }
  
  customElements.define(
    'judge-me-review-widget',
    class JudgemeReviewWidget extends HTMLElement {
      constructor() {
        super();
        this.productId = this.dataset.productId;
        this.shopDomain = this.dataset.shopDomain;
        this.publicToken = this.dataset.publicToken;
        this.reviewWidgetEl = this.querySelector('[data-review-widget]');
        this.medalsEl = this.querySelector('[data-medals]');
        this.actionsEl = this.querySelector('[data-actions]');
        this.observer = null;
      }
    
      connectedCallback() {
        this.initMutationObserver();
        setTimeout(() => {
          this.medalsEl.append(this.querySelector('.jdgm-row-media'));
          
        }, 1000)
        this.addEventListener('click', e => {
          if (e.target.closest('.jdgm-paginate__page[role="button"]')) this.reviewWidgetEl.innerHTML = ``;
          if (e.target.closest('[data-write-review]')) this.querySelector('.jdgm-write-rev-link')?.click();
        })
      }
      
      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
      }
      
      initMutationObserver() {
        const callback = (mutationsList) => {          
          for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
              if (mutation.target.closest('#judgeme_product_reviews')) {
                this.parseReviews(mutation.target.closest('[data-review-id]'));
              }
            }
          }
        };

        const config = { childList: true, subtree: true };

        this.observer = new MutationObserver(callback);
        this.observer.observe(this, config);
      }
      
      parseReviews(review) {
        if (!review || this.reviewWidgetEl.querySelector(`[data-review-id="${review?.dataset?.reviewId}"]`)) return;
        const li = document.createElement('li');
        review.className = '';
        review.classList.add('custom-judgeme-review');
        
        review.querySelector('.jdgm-rev__actions')?.remove();
        review.querySelector('.jdgm-rev__icon')?.remove();
        review.querySelector('.jdgm-rev__buyer-badge-wrapper')?.remove();
        review.querySelector('.jdgm-rev__br')?.remove();
        
        review.querySelector('.jdgm-rev__header').insertAdjacentHTML('beforeEnd', `<span class="date">${getFormattedDate(review.querySelector('.jdgm-rev__timestamp[data-content]')?.dataset.content)}</span>`);
        review.querySelector('.jdgm-rev__timestamp')?.remove();
        
        const reviewLocation = review.querySelector('.jdgm-rev__location');
        reviewLocation.innerText = reviewLocation.innerText.replace(/[()]/g, '');
        
        review.querySelector('.jdgm-rev__author').insertAdjacentHTML('afterBegin', `
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
            <path d="M6.12785 1.67438C6.94675 0.775208 8.36154 0.775208 9.18044 1.67438C9.59436 2.12887 10.1892 2.37526 10.8032 2.34655C12.018 2.28977 13.0185 3.29025 12.9617 4.50508C12.933 5.11907 13.1794 5.71393 13.6339 6.12785C14.5331 6.94675 14.5331 8.36154 13.6339 9.18044C13.1794 9.59436 12.933 10.1892 12.9617 10.8032C13.0185 12.018 12.018 13.0185 10.8032 12.9617C10.1892 12.933 9.59436 13.1794 9.18044 13.6339C8.36154 14.5331 6.94675 14.5331 6.12785 13.6339C5.71393 13.1794 5.11907 12.933 4.50508 12.9617C3.29025 13.0185 2.28977 12.018 2.34655 10.8032C2.37526 10.1892 2.12887 9.59436 1.67438 9.18044C0.775208 8.36154 0.775208 6.94675 1.67438 6.12785C2.12887 5.71393 2.37526 5.11907 2.34655 4.50508C2.28977 3.29025 3.29025 2.28977 4.50508 2.34655C5.11907 2.37526 5.71393 2.12887 6.12785 1.67438Z" stroke="black"/>
            <path d="M5.56543 7.65464L6.9575 9.04658L9.74138 6.2627" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>`
        );
        
        li.append(review);
        review.querySelector('.jdgm-rev__author-wrapper').append(reviewLocation);
        li.append(review.querySelector('.jdgm-rev__author-wrapper'));
        this.reviewWidgetEl.append(li);
      }
    }
  )
}